import React, { Component } from "react";
import axios from "axios";
import ExamInstruction from "./exam_instruction";
import { CiLock } from "react-icons/ci";
import { Link } from "react-router-dom";

class UserExamSection extends Component {
    state = {
        exam: [],
        course: this.props.course || [],
        selectedExam: []
    }



    componentDidMount() {
        this.fetchCourses();
    }
    componentDidUpdate(prevProps) {
        if (this.props.shouldRefresh && this.props.shouldRefresh !== prevProps.shouldRefresh) {
            this.fetchCourses();
            this.props.onRefreshDone(); // Important: Call the callback to reset the flag
        }
    }
    fetchCourses = async () => {
        const accessToken = localStorage.getItem("accessToken");

        try {
            const course_id = this.props.course_id
            const courseId = parseInt(course_id, 10);
            const response = await axios.get(`https://api.geoinfoacademy.com/api/student/exams/by-course/${courseId}/`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            this.setState({ exam: response.data });
            console.log("API Response for list of exam:", response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };


    handleExamInstruction = (id) => {
        const { exam } = this.state
        const selectExam = exam.find((item) => Number(item.id) === Number(id))
        this.setState({
            selectedExam: selectExam
        })
        const formcontainer = document.querySelector(".dash_add_course_cover.examinstruction")
        formcontainer.style.display = "flex"

    }




    handleRedirect = async () => {
        const accessToken = localStorage.getItem("accessToken");
        const course_id = this.props.course_id
        if (accessToken) {
            // Navigate if already logged in
         
        try {
            const response = await axios.post(
                `https://api.geoinfoacademy.com/api/interested-courses/`,
                {
                    course_id: course_id, // Place course_id in the request body
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            console.log(response.data.message)
            window.location.href = `/description/${course_id}/paymentverify`; 
        }
        catch (error) {
            console.error("Error initiating payment:", error);
        }

    }else {
            localStorage.setItem('redirectCourseId', course_id); // Store course ID
            localStorage.setItem('redirectCourseaction', "apply");
            window.location.href = '/login'; // Redirect to login
        }
    };


    render() {
        const { course } = this.state
        const document = this.state.exam;
        const examlist =
            // document && document.documents && 
            document.length > 0 ?
                document.map((exam) => {
                    return (
                        <>
                        {exam.taken ? <Link to={`/exam-score/${exam.id}/${this.props.course_name}/${this.props.course_id}`}><li className="document" key={exam.id}>
                            {/* <IoDocumentsSharp />  */}
                            <span>{exam.title}</span>
                            {/* <button onClick={() => this.handleDownload(exam.id)} className="download"><MdOutlineFileDownload /></button> */}
                            {/* <button onClick={() => this.handleDelete(exam.id)} className="download"><MdOutlineDeleteOutline /></button> */}
                        </li></Link> : 
                        <li className="document" key={exam.id} onClick={() => this.handleExamInstruction(exam.id)}>
                            {/* <IoDocumentsSharp />  */}
                            <span>{exam.title}</span>
                            {/* <button onClick={() => this.handleDownload(exam.id)} className="download"><MdOutlineFileDownload /></button> */}
                            {/* <button onClick={() => this.handleDelete(exam.id)} className="download"><MdOutlineDeleteOutline /></button> */}
                        </li>}
                        </>
                    ); 
                })
                : (
                    <li className="document">
                        {/* <GrDocumentExcel />  */}
                        Awaiting exam upload
                    </li>
                );
        return (
            <>
                <section className="exam_container">
                    <h4>Exam</h4>
                    <div className="exam_cover">
                        {course.enrolled ?
                            examlist :
                            <div className="enroll_error">
                                <div className="enroll_cover">
                                    <CiLock />
                                    <p>Enroll For Course To Gain Access</p>
                                    <button onClick={this.handleRedirect}>Apply For Course</button>
                                </div>
                            </div>
                        }
                    </div>
                </section>
                <ExamInstruction instruction = {this.state.selectedExam} width = {this.props.width}/>
            </>
        )
    }
}


export default UserExamSection